import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '@monorepo/store';
import App from './App';
import PwaPrompts from './components/PwaPrompts';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      {/* Service-worker update prompt and offline indicator. Mounted beside
          the app rather than inside it so it survives route changes and is
          never unmounted by a page-level error boundary. */}
      <PwaPrompts />
    </Provider>
  </React.StrictMode>
);
